import React from "react";

import faildtransaction from "../../../assets/images/faildtransaction.svg";

const InvalidPaymentFormPage = () => {
  return (
    <div className="w-full h-full min-h-screen flex justify-center items-center bg-primary-50 py-3">
      <div className="w-[720px] h-fit flex flex-col justify-start items-center rounded-v-4xl p-9 bg-neutral-10 gap-2">
        <img className=" rounded-v-4xl" src={faildtransaction} alt="success-transaction" />
        <p className="text-error-90 p-6 text-title-2xl-semibold">فرم نامعتبر است!</p>
      </div>
    </div>
  );
};

export default InvalidPaymentFormPage;
